import { render, staticRenderFns } from "./VButtonReport.vue?vue&type=template&id=10ac3042&"
import script from "./VButtonReport.vue?vue&type=script&lang=ts&"
export * from "./VButtonReport.vue?vue&type=script&lang=ts&"
import style0 from "./VButtonReport.vue?vue&type=style&index=0&id=10ac3042&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports